// Form previews use saved rates; aggregate totals are supplied by the server.
export function reservationMoneyPreview(amount, reservation, marketRates) {
  const currency = reservation.currency || 'EUR';
  const rate = currency === 'EUR' ? 1 : reservation.update_exchange_rate
    ? (marketRates?.[currency] > 0 ? 1 / marketRates[currency] : null)
    : Number(reservation.exchange_rate_to_eur);
  return rate > 0 && Number.isFinite(rate) ? Number(amount || 0) * rate : null;
}
export const missingReservationRateText = {
  ko: '환율이 없는 예약은 EUR 합계에서 제외되었습니다.',
  en: 'Reservations without a saved exchange rate are excluded from EUR totals.',
  fr: 'Les réservations sans taux enregistré sont exclues des totaux EUR.'
};
